/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExportCommentsQueryVariables = Types.Exact<{
  scheduledSurveyId: Types.Scalars['Int'];
  language?: Types.InputMaybe<Types.Supported_Language_Code>;
  attributeValueIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type ExportCommentsQuery = { exportComments: string };


export const ExportCommentsDocument = gql`
    query ExportComments($scheduledSurveyId: Int!, $language: Supported_language_code, $attributeValueIds: [Int!]!) {
  exportComments(scheduledSurveyId: $scheduledSurveyId, language: $language, attributeValueIds: $attributeValueIds)
}
    `;

/**
 * __useExportCommentsQuery__
 *
 * To run a query within a React component, call `useExportCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCommentsQuery({
 *   variables: {
 *      scheduledSurveyId: // value for 'scheduledSurveyId'
 *      language: // value for 'language'
 *      attributeValueIds: // value for 'attributeValueIds'
 *   },
 * });
 */
export function useExportCommentsQuery(baseOptions: Apollo.QueryHookOptions<ExportCommentsQuery, ExportCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCommentsQuery, ExportCommentsQueryVariables>(ExportCommentsDocument, options);
      }
export function useExportCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCommentsQuery, ExportCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCommentsQuery, ExportCommentsQueryVariables>(ExportCommentsDocument, options);
        }
export type ExportCommentsQueryHookResult = ReturnType<typeof useExportCommentsQuery>;
export type ExportCommentsLazyQueryHookResult = ReturnType<typeof useExportCommentsLazyQuery>;
export type ExportCommentsQueryResult = Apollo.QueryResult<ExportCommentsQuery, ExportCommentsQueryVariables>;